import React from "react"
import ReactDOM from "react-dom/client"
//import "@webcomponents/custom-elements/src/native-shim"
//import "@webcomponents/custom-elements"
import { RouterProvider } from "react-router-dom"
import router from "./routes/router"
import reportWebVitals from "./reportWebVitals"

import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import "./index.scss"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    <ToastContainer />
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
